import type { WorkOrderState } from '@chukua/common';
import { Alert } from 'antd';
import type { ReactNode } from 'react';

interface VerificationPromptProps {
  orderState: WorkOrderState;
  canManage: boolean;
  refusal: string | null;
  form: ReactNode;
}

/** What the viewer can do about verifying right now: fill in the form, be told it needs someone else, or wait until the work is complete. */
export function VerificationPrompt({ orderState, canManage, refusal, form }: VerificationPromptProps) {
  if (orderState === 'verified_closed') return null;
  if (orderState !== 'completed') return <p className="m-0 text-muted">Verification opens once the work is marked complete.</p>;
  if (!canManage) return null;
  if (refusal) return <Alert type="warning" showIcon title="This needs a second person" description={refusal} />;
  return form;
}
